import { FC, useEffect, useState } from "react";
import { useAuthStore } from "../../hooks/useAuthStore";
import { useTicketStore } from "../../hooks/useTicketStore";
import { Button, Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ApiStatus } from "../../types/api/status";
import { Ticket } from "../../types/slices/ticketType";
import { RoutesMap } from "../../types";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { moneyCL } from "../../toolbox/helpers/money-helpers";

const columns = [
    { type: "checkbox", field: "", label: "", align: "center" },
    { type: 'text', field: 'date', label: 'Fecha', align: 'center' },
    { type: 'text', field: 'folio', label: 'Folio', align: 'center' },
    { type: 'text', field: 'name_customer', label: 'Cliente', align: 'center' },
    { type: 'text', field: 'type_document', label: 'Tipo', align: 'center' },
    { type: 'text', field: 'net_total', label: 'Total neto', align: 'center', format: (row) => moneyCL(row.net_total || 0) },
    { type: 'text', field: 'total_discount', label: 'Descuento', align: 'center', format: (row) => moneyCL(row.total_discount || '0') },
    { type: 'text', field: 'IVA', label: 'IVA', align: 'center', format: (row) => moneyCL(row.IVA || 0) },
    { type: 'text', field: 'total', label: 'Total', align: 'center', format: (row) => moneyCL(row.total || 0) },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
]

const breadcrumbs = [
    { id: 1, label: 'Contabilidad' },
    { id: 2, label: 'Guias de despacho', pathname: RoutesMap.NC_LIST }
]

export const DispatchGuideList: FC = () => {

    const { user } = useAuthStore()
    const { status, tickets, getTicket, deleteTicket, createRelationTicket } = useTicketStore()
    const [selectedOrders, setSelectedOrders] = useState<number[]>([]);
    const [allSelected, setAllSelected] = useState<boolean>(false);

    useEffect(() => {
        getTicketApi()
    }, [])

    const getTicketApi = async () => {
        await getTicket({ status_invoice_route: ['1', '2'], type_document: 7})
    }

    const onDetails = (rowSelected: Ticket) => {
        if (rowSelected.url_invoice === '') return

        window.open(rowSelected.url_invoice, "_blank")
    }

    const isSelected = (row: any) => selectedOrders.some(selectedRow => selectedRow === row.id);

    const selectAllRows = () => {
        if (allSelected) {
            setSelectedOrders([]);
            setAllSelected(false);
        } else {
            const allIds = tickets.map((ticket) => ticket.id);
            setSelectedOrders(allIds);
            setAllSelected(true);
        }
    };

    const handleSelectOrder = (row) => {
        setSelectedOrders((prev) =>
            prev.includes(row.id) ? prev.filter((orderId) => orderId !== row.id) : [...prev, row.id]
        );
    };

    const handleGroupOrders = async () => {
        const groupedOrderIds = selectedOrders;
        await createRelationTicket({ idtickets_child: groupedOrderIds })
        await getTicketApi()
        setSelectedOrders([]);
        setAllSelected(false);
    };

    const canGroupOrders = () => {
        if (selectedOrders.length < 2) return false;

        const selectedPedidos = tickets.filter(pedido => selectedOrders.includes(pedido.id));

        if (!selectedPedidos.every(p => p.idtype_document === 7)) {
            return false;
        }

        const firstPedido = selectedPedidos[0];
        return selectedPedidos.every(p =>
            p.idcustomer === firstPedido.idcustomer &&
            p.idclient_address === firstPedido.idclient_address &&
            p.idcompany === firstPedido.idcompany &&
            p.idway_to_pay === firstPedido.idway_to_pay &&
            p.bussines_area === firstPedido.bussines_area
        );
    };
    
    return (
        <>
            <Grid item xs={12}>
                <CustomTable
                    breadcrumbs={breadcrumbs}
                    title={'Guias de despacho'}
                    columns={columns}
                    rows={tickets || []}
                    loading={status === ApiStatus.FETCHING}
                    onRowClick={() => { }}
                    isSelected={isSelected}
                    selectAll={selectAllRows}
                    allSelected={allSelected}
                    onCheckbox={handleSelectOrder}
                    hasOptions
                    onDetails={onDetails}
                    dense

                    
                    onAddFn={handleGroupOrders}
                    disabledAdd={!canGroupOrders()}
                    onAddFnName={'Agrupar Seleccionados'}
                />
            </Grid>
        </>

    )
}